// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import {
  addHouseHistory,
  deleteHouseHistory,
  updateHouseHistory,
} from '../../../actions/informationHistoryActions';

import DateText from '../../DateText.jsx';
import Table from '../../Table.jsx';
import Typeahead from '../../Typeahead.jsx';

type Props = {
  dob: string,
  houseHistory: Object[],
  activePatientId: string,
  addHouseHistory: Function,
  deleteHouseHistory: Function,
  updateHouseHistory: Function,
}

class HouseHistoryComponent extends Component<Props> {
  /* eslint-disable no-param-reassign */
  transformDates(formValues) {
    formValues.from = moment(formValues.from, 'DD-MM-YYYY').toISOString();
    formValues.to = moment(formValues.to, 'DD-MM-YYYY').toISOString();
  }

  handleDeleteRow = (id: string) => {
    this.props.deleteHouseHistory(this.props.activePatientId, id);
  }

  handleSaveRow = (id: string, formData: Object) => {
    this.transformDates(formData.values);
    this.props.updateHouseHistory(this.props.activePatientId, {
      houseHistoryId: id,
      ...formData.values,
    });
  }

  handleSaveNewRow = (formData: Object) => {
    this.transformDates(formData.values);
    this.props.addHouseHistory(this.props.activePatientId, formData.values);
  }

  render() {
    const { dob, houseHistory } = this.props;

    const columns = [
      {
        Header: 'House',
        id: 'house',
        editCell: item => <Typeahead field='house' initialValue={item.house} endpoint='house' />,
      },
      {
        Header: 'Start Age',
        id: 'startAge',
        cell: (item) => {
          if (!item.from) {
            return '--';
          }
          const startDate = moment(item.from);
          const years = startDate.diff(dob, 'years');
          startDate.subtract(years, 'years');
          const months = startDate.diff(dob, 'months');
          return `${years} y, ${months} m`;
        },
      },
      {
        Header: 'From',
        id: 'from',
        cell: item => (item.from ? moment(item.from).format() : '--'),
        editCell: item => <DateText field='from' item={item} />,
      },
      {
        Header: 'To',
        id: 'to',
        cell: item => (item.to ? moment(item.to).format() : '(ongoing)'),
        editCell: item => <DateText field='to' item={item} nullable />,
      },
    ];

    return (
      <Table
        columns={columns}
        data={houseHistory}
        handleDeleteRow={this.handleDeleteRow}
        handleSaveRow={this.handleSaveRow}
        handleSaveNewRow={this.handleSaveNewRow}
      />
    );
  }
}

const mapStateToProps = state => ({
  dob: state.patient.data.generalInfo.dob,
  houseHistory: state.patient.data.houseHistory,
  activePatientId: state.patient.data.activePatientId,
});

const mapDispatchToProps = dispatch => ({
  addHouseHistory:
    (patientId, houseHistory) => dispatch(addHouseHistory(patientId, houseHistory)),
  deleteHouseHistory:
    (patientId, houseHistoryId) => dispatch(deleteHouseHistory(patientId, houseHistoryId)),
  updateHouseHistory:
    (patientId, houseHistory) => dispatch(updateHouseHistory(patientId, houseHistory)),
});

const HouseHistory = connect(
  mapStateToProps,
  mapDispatchToProps,
)(HouseHistoryComponent);

export default HouseHistory;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/informationHistory/HouseHistory.jsx